<template>
    <QuestionBaseQuiz :question="question">
        <div class="mt-1">
            <FormLabel :value="$t('messages.answer')" :for="`answer_${question.question_id}`" />
            <!-- native modifier has been removed, please confirm whether the function has been affected  -->
            <FormInput
                id="title"
                v-model.trim.lazy="answer"
                :name="`answer_${question.question_id}`"
                @keypress.enter.prevent
                type="text"
                maxlength="180"
                class="mt-1 w-full"
            />

            <div class="mt-1">
                <button @click="answer = null" :class="{ invisible: !answer }" class="text-gray-600" type="button">
                    <svg
                        class="w-6 h-6 inline-block"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    {{ $t('messages.delete_answer') }}
                </button>
            </div>

            <AlertMessage class="mt-5 inline-block" v-if="question.is_case_sensitive">
                <template v-slot:title>
                    {{ $t('messages.warning') }}
                </template>
                <template v-slot:body>
                    {{ $t('messages.case_sensitive_question_warning') }}
                </template>
            </AlertMessage>
        </div>
    </QuestionBaseQuiz>
</template>

<script>
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';

export default {
    emits: ['update:modelValue'],
    name: 'QuestionShortAnswerQuiz',
    components: {
        QuestionBaseQuiz,
        FormInput,
        FormLabel,
        AlertMessage,
    },
    props: {
        question: {
            required: true,
        },
        modelValue: {
            required: true,
        },
    },
    data() {
        return {
            answer: this.modelValue,
        };
    },
    watch: {
        answer(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
